import React from 'react'
import Portfolio from '../Portfolio'
import Div from '../Div'
import Slider from 'react-slick';

export default function PortfolioSlider({ data, variant }) {
  const portfolioData = data || [
    {
      title: "Atividades Psicomotoras",
      subtitle: "Ver Detalhes",
      href: "#",
      src: "/images/tia-paty/portifolio-tia_paty-1.png",
    },
    {
      title: "Desenvolvimento Infantil",
      subtitle: "Ver Detalhes",
      href: "#",
      src: "/images/tia-paty/portifolio-tia_paty-2.png",
    },
    {
      title: "Estimulação Sensorial",
      subtitle: "Ver Detalhes",
      href: "#",
      src: "/images/tia-paty/portifolio-tia_paty-3.png",
    },
    {
      title: "Coordenação Motora",
      subtitle: "Ver Detalhes",
      href: "#",
      src: "/images/tia-paty/portifolio-tia_paty-4.png",
    },
    {
      title: "Equilíbrio e Movimento",
      subtitle: "Ver Detalhes",
      href: "#",
      src: "/images/tia-paty/portifolio-tia_paty-7.png",
    },
    {
      title: "Expressão Corporal",
      subtitle: "Ver Detalhes",
      href: "#",
      src: "/images/tia-paty/portifolio-tia_paty-5.png",
    },
    {
      title: "Autonomia e Confiança",
      subtitle: "Ver Detalhes",
      href: "#",
      src: "/images/tia-paty/portifolio-tia_paty-6.png",
    },
  ]
  
  /** Slider Settings **/
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 3,
    speed: 600,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          centerPadding: "0"
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          centerPadding: "0"
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px"
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px"
        }
      }
    ]
  };
  
  return (
    <Slider {...settings} className='cs-slider cs-style3 cs-gap-24'>
      {portfolioData.map((item, index)=> (
        <Div key={index}>
          <Portfolio
            title={item.title}
            subtitle={item.subtitle}
            href={item.href}
            src={item.src}
            variant={variant || 'cs-style'}
          />
        </Div>
      ))}
    </Slider>
  )
}
